import { ReactNode } from "react";

import AlertTriangleIcon from "@assets/icons/alert-icon.svg";

interface IUploaderErrorsProps {
  errorMessages: ReactNode[];
}

export function UploaderErrors({ errorMessages }: IUploaderErrorsProps) {
  if (!errorMessages.length) return null;

  return (
    <div className="relative mt-1 flex cursor-auto flex-col gap-0.5">
      {errorMessages.map((errorMessage, index) => (
        <div
          key={index}
          className="flex items-center gap-3 rounded-lg border border-stroke-primary bg-red-50 p-2"
        >
          <AlertTriangleIcon width={20} height={20} className="flex-shrink-0 text-red-600" />
          <span className="text-sm text-content-error">{errorMessage}</span>
        </div>
      ))}
    </div>
  );
}
